import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Paper } from 'components/UI'
// theme
import { colors } from 'themes/index'

export const FloatingBottomPaper = styled((props) => <Paper square {...props} />)`
  && {
    background: ${colors.gray200};
    bottom: 0;
    padding: 10px 20px;
    position: fixed;
    width: 100%;
    z-index: 999999999;
  }
`

export const ChangedLabel = styled('div')`
  align-items: center;
  color: ${colors.purple300};
  display: flex;
  font-size: 14px;
  height: 100%;
  justify-content: center;
  text-decoration-color: ${colors.purple300};
  text-decoration: underline;
`
